export default __webpack_public_path__ + "static/media/now-logo.30158bbc.svg";